import { ApiError, getStoredAccessToken } from "./client";

export function isLibrarySaveEnabled() {
  return true;
}

function buildLibraryHeaders() {
  const headers = {};
  const token = getStoredAccessToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function saveLibraryItem(formData, { signal } = {}) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL ?? "").trim();
  const url = `${baseUrl.replace(/\/$/, "")}/library/items`;
  const res = await fetch(url, {
    method: "POST",
    headers: buildLibraryHeaders(),
    body: formData,
    signal,
  });

  if (!res.ok) {
    let message = res.statusText || "Save to library failed";
    try {
      const body = await res.json();
      if (typeof body.detail === "string") {
        message = body.detail;
      }
    } catch {
      // ignore non-JSON bodies
    }
    throw new ApiError(message, res.status);
  }

  return res.json();
}

export async function listLibraryItems({ toolId, limit, signal } = {}) {
  const { apiGet } = await import("./client");
  const params = new URLSearchParams();
  if (toolId) {
    params.set("toolId", toolId);
  }
  if (limit != null && limit > 0) {
    params.set("limit", String(limit));
  }
  const query = params.toString();
  return apiGet(`/library/items${query ? `?${query}` : ""}`, { signal });
}

export async function getLibraryItem(libraryItemId) {
  const { apiGet } = await import("./client");
  return apiGet(`/library/items/${encodeURIComponent(libraryItemId)}`);
}

export async function getLibraryItemSnapshot(libraryItemId, { signal } = {}) {
  const { apiGet } = await import("./client");
  return apiGet(`/library/items/${encodeURIComponent(libraryItemId)}/snapshot`, { signal });
}

export async function getLibraryItemVersions(libraryItemId, { signal } = {}) {
  const { apiGet } = await import("./client");
  return apiGet(`/library/items/${encodeURIComponent(libraryItemId)}/versions`, { signal });
}

export async function getLibraryArtifactDownloadUrl(libraryItemId, artifactId) {
  const { apiGet } = await import("./client");
  return apiGet(
    `/library/items/${encodeURIComponent(libraryItemId)}/artifacts/${encodeURIComponent(artifactId)}/download`,
  );
}
